import { render, staticRenderFns } from "./ReplyItem.vue?vue&type=template&id=ee2e636c&scoped=true&"
import script from "./ReplyItem.vue?vue&type=script&lang=js&"
export * from "./ReplyItem.vue?vue&type=script&lang=js&"
import style0 from "./ReplyItem.vue?vue&type=style&index=0&id=ee2e636c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2e636c",
  null
  
)

export default component.exports